// Zustand slice — Collections notification bell counts.
//
// The TopBar bell lives in the global shell (above the /collections route
// subtree), so the live counts can't ride the Collections outlet context.
// This module-level store is the carrier: useCollectionsNotifications() (an
// SSE subscription mounted once in AppShell) writes the counts here, and
// TopBar reads them to render the badge + popover.
//
// `receiptsNeedingAction` collapses the two receipt buckets (pending review +
// approved-but-unsent) into the single number the bell shows.

import { create } from 'zustand';

export interface CollectionsCounts {
  pendingReceipts: number;
  approvedUnsentReceipts: number;
  cancellationRequests: number;
  /** Bookings a receipt completed after cancellation, not yet acknowledged. */
  completedAfterCancellation: number;
}

interface CollectionsNotifState {
  receiptsNeedingAction: number;
  cancellationRequests: number;
  completedAfterCancellation: number;
  /** True while CollectionsLayout is mounted (bell should render). */
  isActive: boolean;
  setCounts: (counts: CollectionsCounts) => void;
  setActive: (v: boolean) => void;
  reset: () => void;
}

export const useCollectionsNotifStore = create<CollectionsNotifState>((set) => ({
  receiptsNeedingAction: 0,
  cancellationRequests: 0,
  completedAfterCancellation: 0,
  isActive: false,
  setCounts: (c) =>
    set({
      receiptsNeedingAction: c.pendingReceipts + c.approvedUnsentReceipts,
      cancellationRequests: c.cancellationRequests,
      completedAfterCancellation: c.completedAfterCancellation,
    }),
  setActive: (v) => set({ isActive: v }),
  reset: () =>
    set({
      receiptsNeedingAction: 0,
      cancellationRequests: 0,
      completedAfterCancellation: 0,
      isActive: false,
    }),
}));
